import { postJson, postFile } from '../../http'

export default {
    /**
     * 通用请求
     * @param {*} url 
     * @param {*} data 
     */
    sendMessage(url, data) {
        return postJson(url, data)
    },
    /**
     * 通用上传url
     */
    uploadUrl() {
        return '/lz/platform/upload/file'
    },
    /**
     * 通用字典查询
     * @param {*} data 
     */
    fetchDictList(data) {
        return postJson('/lz/platform/dict/list', data)
    },
    /**
     * 省市区列表
     *
     * @returns
     */
    fetchRegions() {
        return postJson('/lz/platform/address/province/city/district')
    },
    /**
     * 省市列表
     *
     * @returns
     */
    fetchRegions2() {
        return postJson('/lz/platform/address/province/city')
    },
    /**
     * 文件上传
     * @param {*} data 
     */
    uploadFile(data) {
        return postFile('/lz/platform/upload/file', data)
    },
    /**
     * 工作台信息加载
     *
     * @param {*} data
     * @returns
     */
    loadViewData(data) {
        // return postJson('/lz/console/index/load', data)
    },
    /**
     * 校验组织是否存在
     *
     * @returns
     */
    checkOrganization(params) {
        return postJson('/lz/console/organization/check/checkOrganization', params)
    },

    /**
     * 通过上传文件名获取文件url
     */
    filePreview(params) {
        return postJson('/lz/platform/file/preview', params)
    }
}



// WEBPACK FOOTER //
// ./src/api/modules/main/common.js